import { blue, green, orange, red } from '@mui/material/colors';
export const Alert = {
  MuiAlert: {
    styleOverrides: {
      root: {
        marginBottom: '16px',
        borderRadius: '4px',
      },
    },
    variants: [
      {
        props: { variant: 'outlined', severity: 'error' },
        style: {
          backgroundColor: red[50],
        },
      },
      {
        props: { variant: 'outlined', severity: 'info' },
        style: {
          backgroundColor: blue[50],
        },
      },
      {
        props: { variant: 'outlined', severity: 'warning' },
        style: {
          backgroundColor: orange[50],
        },
      },
      {
        props: { variant: 'outlined', severity: 'success' },
        style: {
          backgroundColor: green[50],
        },
      },
    ],
  },
};
